import { createSelector } from "@ngrx/store";
import { AppState } from "../app.state";

export const selectThemeState = (state: AppState) => state.providedTheme;

export const selectThemeToken = createSelector(
  selectThemeState,
  (state) => state.currentTheme
);
